import React from 'react';
import { gikClassPrefix } from '@gik/core/constants';
import classnames from 'classnames';
import { BaseBoneProps } from '@gik/ui/SkeletonLoader/Bones/BaseBone';
import WordBone from '@gik/ui/SkeletonLoader/Bones/WordBone';
import repeatElement from '@gik/core/utils/repeatElement';

const blockName = `${gikClassPrefix}-list-bone`;

export interface ListBoneProps extends BaseBoneProps {
  entries?: number;
  constantWidth?: boolean;
}

export default function ListBone({ className, entries = 10, constantWidth = true }: ListBoneProps) {
  const blockClasses = classnames([blockName, className || '']);

  return (
    <ul className={blockClasses}>
      {repeatElement(
        Math.round(entries),
        <li>
          <WordBone width={constantWidth ? 100 : undefined} />
        </li>
      )}
    </ul>
  );
}
